import type { TModalConfig } from '~/interfaces/content/modals';
import {
  UserDemoPlayAcknowledgeDemoPlay,
  UserDemoPlayAcknowledgeRealPlay,
  UserDemoPlaySuggestRealPlay,
  UserDemoPlaySuggestReg,
} from '#components';

export const demoPlayModals: TModalConfig = {
  demoPlayLaunchAlert: {
    modalProps: {
      title: 'demo-play-launch-alert',
    },
    component: () => UserDemoPlayAcknowledgeDemoPlay,
  },
  demoPlayRegPrompt: {
    modalProps: {
      title: 'demo-play-reg-prompt',
    },
    component: () => UserDemoPlaySuggestReg,
  },
  realPlayLaunchAlert: {
    modalProps: {
      title: 'real-play-launch-alert',
    },
    component: () => UserDemoPlayAcknowledgeRealPlay,
  },
  switchToRealPlayPrompt: {
    modalProps: {
      title: 'switch-to-real-play-prompt',
    },
    component: () => UserDemoPlaySuggestRealPlay,
  },
} as const satisfies TModalConfig;
